import {
  Component, EventEmitter,
  OnInit
} from '@angular/core';
import {
  FlowDescriptionsTransport,
  NetscopeApiService,
  Success,
  Response
} from "@app/services/netscope-api.service";
import {
  Router
} from "@angular/router";
import {
  combineLatest,
  Subscription
} from "rxjs";
import * as yaml from "js-yaml";
import {TranslocoService} from "@ngneat/transloco";
import {NetscopeUiService} from "@app/services/netscope-ui.service";
import {
  FlowDescriptionEndpoint,
  FlowDescriptionNetworkRule,
  FlowDescriptionRule,
  TemporalParameter
} from "@app/netscope/model/data-models";
import {
  AppsGroupsResolver,
  describeEndpoint,
  FlowDescriptionEndpointDescription
} from "@app/netscope/model/apps-groups-resolver";
import {DescriptionCoverage, FlowsRepository, SrcTargetResourceTypeData} from "@app/netscope/model/flows-repository";
import {EChartsOption} from "echarts";
import {NetscopeUtils} from "@app/netscope/netscope-utils";


@Component({
  standalone: false,
  selector: 'app-netscope-flows-descriptions',
  templateUrl: './netscope-flows-descriptions.component.html',
  styleUrls: ['./netscope-flows-descriptions.component.css']
})
export class NetscopeFlowsDescriptionsComponent implements OnInit {

  flowsDescriptionsData: FlowDescriptionRule[] = [];
  isLoading: boolean = false;
  isPushingFlowsDescriptions: boolean = false;
  failureMode = false;

  hideNotReady: boolean = false;

  flowsRepository: FlowsRepository;
  describedFlowsRepository: FlowsRepository;
  unauthorizedFlowsRepository: FlowsRepository;
  authorizedFlowsRepository: FlowsRepository;
  undescribedFlowsRepository: FlowsRepository;
  flowsRepositoryModal: FlowsRepository;

  showFlowModal: boolean = false;
  selectFlowDetailsModalTitle = "";

  showFlowDescriptionModal: boolean = false;
  editedFlowDescription: FlowDescriptionRule;

  showNetworkRuleModal: boolean = false;
  editedNetworkRule: FlowDescriptionNetworkRule;
  editedNetworkRuleOwner: FlowDescriptionRule;

  temporalParameter: TemporalParameter;
  reloadUiEventEmitter: EventEmitter<any> = new EventEmitter();
  shouldUpdateFilters: EventEmitter<any> = new EventEmitter();
  updateInteval;
  lastDescriptionRules: string = "";

  isDarkMode: boolean = false;

  describedFlowsLabel = "";
  undescribedFlowsLabel = "";

  // Error raised by the last YAML import, if any
  yamlImportError: string = undefined;

  // Apps groups the network rules point to, loaded before the rules are turned into SQL
  appsGroupsResolver: AppsGroupsResolver;

  // Flows each description matches, as computed by the last classification of the flows
  descriptionsCoverage: Map<FlowDescriptionRule, DescriptionCoverage> = new Map();

  classificationChartOptions: EChartsOption;
  coverageGaugeOptions: EChartsOption;
  sankeyOptions: EChartsOption;

  constructor(private netscopeService: NetscopeApiService, private route: Router,
              public translocoService: TranslocoService, private netscopeUiService: NetscopeUiService) {
    this.appsGroupsResolver = new AppsGroupsResolver(netscopeService);
  }

  ngOnInit(): void {
    this.netscopeUiService.temporalParametersSubject.subscribe((newTemporalParameters) => {
      this.temporalParameter = newTemporalParameters;
    })

    this.netscopeUiService.setViewLabel("flows_descriptions.name");
    this.netscopeUiService.setIconShape("note");

    this.reloadData();

    this.updateInteval = setInterval(() => {
      let currentRulesAsJson = JSON.stringify(this.flowsDescriptionsData);
      if (this.lastDescriptionRules != "" && this.lastDescriptionRules != currentRulesAsJson) {
        console.log("I detected a change in the flows descriptions, I will update the rules");
        this.reloadUiEventEmitter.emit();
      }
      this.lastDescriptionRules = currentRulesAsJson;
    }, 1000);

    this.netscopeUiService.darkModeStatusSubject.subscribe((darkModeStatus: boolean) => {
      this.isDarkMode = darkModeStatus;
    });

    // this.shouldFlowsDescriptionsData.subscribe((e) => {
    //   this.updateRuleCoverage();
    // })
    // setInterval(() => {
    //   if (this.shouldUpdate && this.describedFlowsRepository && this.undescribedFlowsRepository) {
    //     this.shouldUpdate = false;
    //     this.updateTopSectionData();
    //     this.checkRulesAndUpdate();
    //   }
    // }, 1000);

    this.reloadUiEventEmitter.subscribe((e) => {
      this.reloadUi();
    })

    // setIt
  }

  async reloadUi() {
      await this.updateRuleCoverage();
      await this.updateTopSectionData();
  }

  // checkRulesAndUpdate = () => {
  //   let currentRulesAsJson = JSON.stringify(this.flowsDescriptionsData);
  //   if (this.lastDescriptionRules != "" && this.lastDescriptionRules != currentRulesAsJson) {
  //     console.log("I detected a change in the flows descriptions, I will update the rules");
  //     this.updateRuleCoverage();
  //   }
  //   this.lastDescriptionRules = currentRulesAsJson;
  // }

  ngOnDestroy = () => {
    if (this.updateInteval != undefined) {
      clearInterval(this.updateInteval);
    }
    this.updateInteval = undefined;
  }

  updateTopSectionData = async() => {
    if (this.describedFlowsRepository != undefined) {
      this.describedFlowsLabel = `${this.describedFlowsRepository.totalItemsCount} flows`;
    }

    if (this.undescribedFlowsRepository != undefined) {
      this.undescribedFlowsLabel = `${this.undescribedFlowsRepository.totalItemsCount} flows`;
    }

    let darkModeTextColor = "white";
    let lightModeTextColor = "#333";

    let textColor = this.isDarkMode ? darkModeTextColor : lightModeTextColor;

    let coverageData = [{
      name: "authorized",
      value: this.authorizedFlowsRepository.totalItemsCount,
      itemStyle: {
        color: "rgb(158, 202, 127)"
      }
    }, {
      name: "unauthorized",
      value: this.unauthorizedFlowsRepository.totalItemsCount,
      itemStyle: {
        color: "#ed2222"
      }
    }];

    this.classificationChartOptions = {
      type: "pie",
      legend: {
        bottom: 0,
      },
      series: [{
        type: 'pie',
        data: coverageData,
        label: {
          show: false,
        }
      }],
    };

    let describedPercentage = 0.0;
    let describedPercentageExchangedBytes = 0.0;

    let totalFlowsCount = this.describedFlowsRepository.totalItemsCount + this.undescribedFlowsRepository.totalItemsCount;
    if (totalFlowsCount > 0) {
      describedPercentage = 100.0 * (this.describedFlowsRepository.totalItemsCount) / (totalFlowsCount);
    }

    let totalExchangedBytes = this.describedFlowsRepository.totalExchangedBytes + this.undescribedFlowsRepository.totalExchangedBytes;
    if (totalFlowsCount > 0) {
      describedPercentageExchangedBytes = 100.0 * (this.describedFlowsRepository.totalExchangedBytes) / (totalExchangedBytes);
    }

    let gaugeData = [
      {
        value: describedPercentage,
        name: 'Flows',
        title: {
          offsetCenter: ['0%', '-5%']
        },
        detail: {
          valueAnimation: true,
          offsetCenter: ['-5%', '-25%'],
          formatter: function (params) {
            return `
             ${params.toFixed(2)} %
            `;
          }
        }
      }, {
        value: describedPercentageExchangedBytes,
        name: 'Traffic',
        title: {
          offsetCenter: ['0%', '35%']
        },
        detail: {
          valueAnimation: true,
          offsetCenter: ['-5%', '15%'],
          formatter: function (params) {
            return `
             ${params.toFixed(2)} %
            `;
          }
        }
      }
    ];

    let sankeyData1 = await this.describedFlowsRepository.getSrcTargetResourceTypesData();
    let sankeyData2 = await this.undescribedFlowsRepository.getSrcTargetResourceTypesData();

    let sankeyData = this.buildSankeyData(sankeyData1, sankeyData2);

    this.coverageGaugeOptions = {
      type: "gauge",
      tooltip: {},
      series: [
        {
          type: 'gauge',
          startAngle: 90,
          endAngle: -270,
          pointer: {
            show: false
          },
          progress: {
            show: true,
            overlap: false,
            roundCap: true,
            clip: false,
            itemStyle: {
              borderWidth: 1,
              borderColor: '#464646'
            }
          },
          axisLine: {
            lineStyle: {
              width: 40
            }
          },
          splitLine: {
            show: false,
            distance: 0,
            length: 10
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false,
            distance: 50
          },
          data: gaugeData,
          title: {
            fontSize: 14
          },
          detail: {
            width: 50,
            height: 14,
            fontSize: 14,
            color: 'inherit',
            borderColor: 'inherit',
            borderRadius: 20,
            borderWidth: 1,
            formatter: '{value}%'
          }
        }
      ]
    };

    this.sankeyOptions = {
      title: [
        { text: "Status",      left: "5%",  top: 0, textStyle: { fontSize: 13 } },
        { text: "Source",      left: "38%", top: 0, textStyle: { fontSize: 13 } },
        { text: "Destination", left: "75%", top: 0, textStyle: { fontSize: 13 } },
      ],
      series: {
        type: 'sankey',
        draggable: false,
        // layout: 'none',
        emphasis: {
          focus: 'adjacency'
        },
        data: sankeyData.data,
        links: sankeyData.links
      }
    };
  }

  clickClassificationChartEventHandler = async (e) => {
    let selectedRepository = e.name.includes("unauthorized") ? this.unauthorizedFlowsRepository : this.authorizedFlowsRepository;

    this.flowsRepositoryModal = selectedRepository.clone();
    // await this.flowsRepositoryModal.init();

    this.showFlowModal = true;

    console.log(e);
  }

  clickSankeyEventHandler = async (e) => {
    let selectedRepository = e.name.includes("undescribed") ? this.undescribedFlowsRepository : this.describedFlowsRepository;

    let srcResourceType = "any";
    let dstResourceType = "any";

    let queryParts = e.name.split(" ");

    for (let part of queryParts) {
      if (!part.includes("src") && !part.includes("dst")) {
        continue;
      }

      let elements = part.split(":");
      if(elements.size < 3) {
        continue;
      }

      // As 'part' is in the form 'described:src:vm', 'elements' should be ['described', 'src', 'vm']
      let resourceType = elements[2];
      if (part.includes("src")) {
        srcResourceType = resourceType
      }
      if (part.includes("dst")) {
        dstResourceType = resourceType
      }
    }

    // Build a where clause
    let whereParts = ["true"];
    if (srcResourceType != "any") {
      whereParts.push(`src_resource_type = '${srcResourceType}'`)
    }
    if (dstResourceType != "any") {
      whereParts.push(`dst_resource_type = '${dstResourceType}'`)
    }

    let cleanedWhereParts = whereParts
      .map((p) => ` ${p} `);

    let whereClause = cleanedWhereParts.join(" and ");
    let init_where_clause = `where ${whereClause}`;

    this.flowsRepositoryModal = selectedRepository.clone();
    await this.flowsRepositoryModal.init(init_where_clause);

    this.showFlowModal = true;


    console.log(e);
  }

  reloadData = () => {
    this.isLoading = true;
    this.failureMode = false;

    this.netscopeService.getFlowsDescriptions().subscribe((resp) => {
      // this.flowsDescriptionsData = flowsDescriptionsTransport.flowsDescriptions;

      if (resp instanceof Success) {
        this.flowsDescriptionsData = resp.element.flowsDescriptions;
        // For object of type FlowDescriptionRule
        this.flowsDescriptionsData = this.flowsDescriptionsData.map((r) => FlowDescriptionRule.from(r));

        this.failureMode = false;
        this.isLoading = false;
      } else {
        this.failureMode = true;
        this.isLoading = false;
        return;
      }

      this.loadDataAndUpdateRuleCoverage();

      this.isLoading = false;
    });
  }

  loadDataAndUpdateRuleCoverage = () => {
    combineLatest([
      this.netscopeUiService.comboboxSelectionItemSubject,
      this.netscopeUiService.clustersFlowDetailsSubject,
      this.netscopeUiService.duckDbRefinedDataSubject
    ])
      .subscribe(async ([comboboxSelectionItems, clustersFlows, duckDbData]) => {
        this.flowsRepository = duckDbData.flowsRepository.clone();

        // this.shouldUpdate = true;
        this.reloadUiEventEmitter.emit();
        // this.updateRuleCoverage();
      });
  }

  updateRuleCoverage = async () => {
    // The apps groups the rules point to are resolved each time, so that the rules follow them as they change
    await this.loadReferencedAppsGroups();

    // Each description matches a flow as soon as one of its network rules matches it. All the flows are classified
    // in a single pass, each description being evaluated once per flow.
    let descriptions = [...this.flowsDescriptionsData];
    let descriptionsClauses = descriptions.map((d) => d.toSqlClause(this.appsGroupsResolver));
    let unauthorizedIndexes = descriptions
      .map((d, index) => d.authorized ? -1 : index)
      .filter((index) => index >= 0);

    let classifiedFlows = await this.flowsRepository.classifyByDescriptions(descriptionsClauses, unauthorizedIndexes);

    this.describedFlowsRepository = classifiedFlows.described;
    this.authorizedFlowsRepository = classifiedFlows.authorized;
    this.unauthorizedFlowsRepository = classifiedFlows.unauthorized;
    this.undescribedFlowsRepository = classifiedFlows.undescribed;

    let firstPage = {
      page: {
        size: 20,
        current: 1
      }
    };
    let repositories = [this.describedFlowsRepository, this.authorizedFlowsRepository,
                        this.unauthorizedFlowsRepository, this.undescribedFlowsRepository];
    await Promise.all(repositories.map((repository) => repository.refresh(firstPage)));

    // The coverage is attached to the descriptions themselves, as their indexes change when one is deleted
    let coverages = await this.describedFlowsRepository.getDescriptionsCoverage();
    this.descriptionsCoverage = new Map();
    for (let coverage of coverages) {
      this.descriptionsCoverage.set(descriptions[coverage.description_index], coverage);
    }

    console.log("update coverage");
  }

  buildSankeyData(describedData: SrcTargetResourceTypeData[], undescribedData: SrcTargetResourceTypeData[]) {

    let mapNodeNames: Map<string, string> = new Map();

    let result = {
      data: [],
      links: []
    };

    let argsObject = {
      "described": describedData,
      "undescribed": undescribedData
    }

    mapNodeNames.set("described", "Described");
    mapNodeNames.set("undescribed", "Undescribed");

    for (let [k, v] of Object.entries(argsObject)) {

      for (let item of v) {
        let srcKey = `${k}:src:${item.src_resource_type}`;
        let dstKey = `${k}:dst:${item.dst_resource_type}`;

        if (!mapNodeNames.has(srcKey)) {
          mapNodeNames.set(srcKey, item.src_resource_type);
        }
        if (!mapNodeNames.has(dstKey)) {
          mapNodeNames.set(dstKey, item.dst_resource_type);
        }

        let newLinks = [{
            source: k,
            target: srcKey,
            value: item.count
          }, {
            source: srcKey,
            target: dstKey,
            value: item.count
        }];
        result.links.push(...newLinks);
      }
    }

    for (let [k, v] of mapNodeNames.entries()) {
      result.data.push({
        name: k,
        label: {
          formatter: v
        }
      });
    }

    console.log("plop");

    return result
  }

  loadReferencedAppsGroups = async () => {
    let files = this.flowsDescriptionsData
      .flatMap((description) => description.networkRules)
      .flatMap((networkRule) => networkRule.appsGroupsReferences())
      .map((reference) => reference.file);

    await this.appsGroupsResolver.loadFiles(files);
  }

  formatBytes = (value: number): string => {
    return NetscopeUtils.formatBytes(Number(value));
  }

  // Label of an end of a network rule, an apps group showing how many resources it stands for right now
  describeEndpoint = (endpoint: FlowDescriptionEndpoint): FlowDescriptionEndpointDescription => {
    return describeEndpoint(endpoint, this.appsGroupsResolver, this.resourceName);
  }

  // Name of a resource of the flows, which the apps groups files do not hold
  resourceName = (uuid: string): string => {
    return this.flowsRepository?.duckDbNodeMapping?.get(uuid)?.name;
  }

  addFlowDescription = () => {
    let flowDescriptionData = FlowDescriptionRule.createDefault();
    this.flowsDescriptionsData.push(flowDescriptionData);
    this.editFlowDescription(flowDescriptionData);
  }

  deleteFlowDescription = (flowDescriptionRule: FlowDescriptionRule) => {
    this.flowsDescriptionsData = this.flowsDescriptionsData
      .filter((rule) => rule != flowDescriptionRule);
  }

  editFlowDescription = (flowDescriptionRule: FlowDescriptionRule) => {
    this.editedFlowDescription = flowDescriptionRule;
    this.showFlowDescriptionModal = true;
  }

  addNetworkRule = (flowDescriptionRule: FlowDescriptionRule) => {
    // A freshly added network rule is empty, so it is directly opened for edition
    let networkRule = flowDescriptionRule.addNetworkRule();
    this.editNetworkRule(flowDescriptionRule, networkRule);
  }

  editNetworkRule = (flowDescriptionRule: FlowDescriptionRule, networkRule: FlowDescriptionNetworkRule) => {
    this.editedNetworkRuleOwner = flowDescriptionRule;
    this.editedNetworkRule = networkRule;
    this.showNetworkRuleModal = true;
  }

  deleteNetworkRule = (flowDescriptionRule: FlowDescriptionRule, networkRule: FlowDescriptionNetworkRule) => {
    flowDescriptionRule.deleteNetworkRule(networkRule);
  }

  // The descriptions are saved in the same shape as the one pushed to the backend, so that a saved file can be
  // imported back as is
  exportFlowsDescriptionsAsYaml = () => {
    let payload = JSON.parse(JSON.stringify({flowsDescriptions: this.flowsDescriptionsData}));
    let yamlContent = yaml.dump(payload, {noRefs: true});

    let blob = new Blob([yamlContent], {
      type: 'application/yaml;charset=utf-8;'
    });
    let url = URL.createObjectURL(blob);
    let link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "flows_descriptions.yaml");
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  // The imported descriptions replace the current ones, and are only kept once the user saves them
  importFlowsDescriptionsFromYaml = (event: Event) => {
    let input = event.target as HTMLInputElement;
    let file = input.files?.[0];
    // Reset the input, so that picking the same file again triggers a new import
    input.value = null;

    if (file == undefined) {
      return;
    }

    this.yamlImportError = undefined;

    file.text().then((content) => {
      try {
        let parsed: any = yaml.load(content);
        let rawDescriptions = Array.isArray(parsed) ? parsed : parsed?.flowsDescriptions;

        if (!Array.isArray(rawDescriptions)) {
          throw new Error("the file should contain a 'flowsDescriptions' list");
        }

        this.flowsDescriptionsData = rawDescriptions.map((r) => FlowDescriptionRule.from(r));
      } catch (e) {
        this.yamlImportError = `Could not import '${file.name}': ${e?.message ?? e}`;
      }
    });
  }

  pushData = () => {
    this.isPushingFlowsDescriptions = true;
    let FlowsDescriptionsDataPayload = {
      flowsDescriptions: this.flowsDescriptionsData
    }
    this.netscopeService.pushFlowsDescriptions(FlowsDescriptionsDataPayload).subscribe((result: Response<object>) => {
      this.isPushingFlowsDescriptions = false;
    })
  }

  setLanguage = (language: "french" | "english") => {
    let languageMap: Map<string, string> = new Map([
      ["french", "fr"],
      ["english", "en"]
    ]);
    let language_code = languageMap.get(language);
    this.translocoService.setDefaultLang(language_code);
    this.translocoService.setActiveLang(language_code);
    localStorage.setItem("language", language_code);
  }

  switchFocus = (vm) => {
  }
}

